module.exports = __webpack_public_path__ + "static/img/foot2.cbc17c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot2.png
// module id = HHFJ
// module chunks = 0